import { isEmpty } from "lodash";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import helpers from "../../Utils/helpers";
import MatchDetails from "../MatchDetails/MatchDetails";
import BackandLay from "../MatchDetails/BackandLay";
import MatchDetailsHome from "../MatchDetails/MatchDetailsHome";
import BackandLayHome from "../MatchDetails/BackandLayHome";
import useOddsDataStore from "../../Utils/zustand/OddsStore";

const InplayTabs = ({
  data,
  type,
  sportsType,
  sportsId,
  handelAddMultiMarket,
  setLoading,
  parlyTab,
}) => {
  let { user, profileData, setSearchToogle, setCasinoModel, setCasinoObj, launchCasino, inPlayScore } = useContext(AuthProvider); // Get inPlayScore from context
  let { handelAddMultiMarket: handelAddMultiMarketBetSlip } = useContext(BetSlipContext);

  const oddsData = useOddsDataStore((state) => state.oddsData);

  const navigate = useNavigate();

  const [slipObj, setSlipObj] = useState({});
  const [selectedBet, setSelectedBet] = useState({
    selectionId: "",
    teamName: "",
    check: "",
  });
  const [key, setKey] = useState("");
  const [betType, setBetType] = useState("betFair");
  const [condi, setCondi] = useState(false);
  const [messaageBox, setMessaageBox] = useState(false);

  const amountRange = {
    min: import.meta.env.VITE_AMOUNT_RANGE_MIN
      ? Number(import.meta.env.VITE_AMOUNT_RANGE_MIN)
      : 1,
    max: import.meta.env.VITE_AMOUNT_RANGE_MAX
      ? Number(import.meta.env.VITE_AMOUNT_RANGE_MAX)
      : 100,
    oddsLimit: 1000,
  };

  const resetSelection = (type) => {
    // Reset selection logic
  };

  const handelBetFairPositions = (data) => {
    // Handle bet fair positions
  };

  // Update data with score from context
  const updatedData = data?.map((item) => {
    let temp = inPlayScore?.find((score) => String(score?.eventId) === String(item?.eventId)); // Ensure string comparison
    if (temp) {
      return {
        ...item,
        score: temp?.current_score || "", // Use current_score from the score object
        timeElapsed: temp?.timeElapsed || "", // Also update timeElapsed if available
      };
    }
    return item;
  });

  useEffect(() => {
    if (oddsData && Object.keys(oddsData).length > 0) {
      const filtered = updatedData.filter((item) => { // Use updatedData here
        const eventId = Object.keys(oddsData)[0];
        return item.eventId == eventId;
      });
    }
  }, [oddsData, updatedData]); // Depend on updatedData

  return (
    <div className="wrap-highlight_list" id="inPlayData">
      <div id="inPlayEventType_4" style={{ display: "block" }}>
        <h3 className="inppayTitle">{sportsType}</h3>
        {/* {sportsType == "Cricket" ? (
          <div className="game_ban">
            <img
              src={
                
                "/assets/images/home/cricketnewbanner.webp"
              }
              alt=""
            />
          </div>
        ) : sportsType == "Tennis" ? (
          <div className="game_ban">
            <img
              src={
                
                "/assets/images/home/tennisnewbanner.webp"
              }
              alt=""
            />
          </div>
        ) : (
          sportsType == "Soccer" && (
            <div className="game_ban">
              <img
                src={
                  
                  "/assets/images/home/soccernewbanner.webp"
                }
                alt=""
              />
            </div>
          )a
        )} */}
        <ul className="highlight-list" style={{marginBottom:"0"}} id="inPlayList_4">
          {updatedData.length > 0 && // Use updatedData here
            updatedData.map((item, index) => { // Use updatedData here
              let filtered = updatedData.filter((oddItem) => oddItem.eventId == item.eventId); // Use updatedData here
              let obj = moment.duration(
                moment(item?.eventDateTime).diff(moment(new Date()))
              )?._data;
              return (
                item.eventType == sportsId && (
                  <>
                  <li
                    id="inPlayEvent_-10362833"
                    key={index}
                    className={`inplay-on ${
                      type == "inplay" ? "inplay-dot-true" : "inplay-dot-false"
                    }`}
                  >
                    <Link
                      id="info"
                      to={`/match-details/${item.eventId}/${item.marketId}`}
                      state={item}
                    >
                      {item?.gameType === "cricket" && (
                        <img
                          src={
                            item?.channel !== "false"
                              ? "../assets/images/cricket-live-icon.png"
                              :  "../assets/images/cricket-off-icon.png"
                          }
                          className="list-image"
                        />
                      )}
                      {item?.gameType === "soccer" && (
                        <img
                          src={
                            item?.channel !== "false"
                              ? 
                                "../assets/images/soccer-live-icon.png"
                              : 
                                "../assets/images/soccer-off-icon.png"
                          }
                          className="list-image"
                        />
                      )}
                      {item?.gameType === "tennis" && (
                        <img
                          src={
                            item?.channel !== "false"
                              ? 
                                "../assets/images/tennis-live-icon.png"
                              : 
                                "../assets/images/tennis-off-icon.png"
                          }
                          className="list-image t4"
                        />
                      )}
                      <dl>
                        <dt>
                          {item?.channel !== "false" && (
                            <span
                              id="streamingIcon"
                              className="game-live"
                              style={{ display: "flex" }}
                            >
                              game-live
                            </span>
                          )}
                          {/* <span
                            id="lowLiquidityTag"
                            className="game-low_liq"
                            style={{ display: "none" }}
                          >
                            Low Liquidity
                          </span> */}
                          {/* <span
                            id="bookMakerIcon"
                            className={`game-bookmaker game-odds ${"in-play"}`}
                            style={{ display: "flex" }}
                          >
                            {<pre>in-play</pre>} Odds
                          </span> */}

                          {item?.bookMaker === "on" && 
                            <span
                              id="bookMakerIcon"
                              className={`game-bookmaker ${"in-play"}`}
                              style={{ display: "flex" }}
                            >
                              {<pre>in-play</pre>} BookMaker
                            </span>
                          }

                          {item?.fancy === "on" && 
                            <span
                              id="fancyBetIcon"
                              className={`game-fancy ${"in-play"
                                }`}
                              style={{ display: "flex" }}
                            >
                              {<pre>in-play</pre>} Fancy
                            </span>
                          }
                          
                          {item?.premiumFancy === "on" && 
                            <span
                              id="feedingSiteIcon"
                              className={`game-sportsbook`}
                              style={{ display: "flex" }}
                            >
                              Sportsbook
                            </span>
                          }

                          {/* <span
                            id="feedingSiteIcon"
                            className={`game-sportsbook`}
                            style={{ display: "flex" }}
                          >
                            Sportsbook
                          </span> */}
                          {/* {item?.channel !== "false" && (
                            <span
                              id="streamingIcon"
                              className="game-live"
                              style={{ display: "flex" }}
                            >
                              {obj.days < 1 && <pre>in-play</pre>} game-live
                            </span>
                          )}
                          <span
                            id="lowLiquidityTag"
                            className="game-low_liq"
                            style={{ display: "none" }}
                          >
                            Low Liquidity
                          </span>
                          {item?.fancyList > 0 && (
                            <span
                              id="fancyBetIcon"
                              className={`game-fancy ${obj.days < 1 && "in-play"
                                }`}
                              style={{ display: "flex" }}
                            >
                              {obj.days < 1 && <pre>in-play</pre>} Fancy
                            </span>
                          )}
                          {item?.bookmakerRunners &&
                            item?.bookmakerRunners?.length > 0 && (
                              <span
                                id="bookMakerIcon"
                                className={`game-bookmaker ${obj.days < 1 && "in-play"
                                  }`}
                                style={{ display: "flex" }}
                              >
                                {obj.days < 1 && <pre>in-play</pre>} BookMaker
                              </span>
                            )}

                          <span
                            id="feedingSiteIcon"
                            className="game-sportsbook"
                            style={{ display: "flex" }}
                          >
                            Sportsbook
                          </span> */}

                          {/* <span
                            id="feedingSiteIcon"
                            className="game-sportsbook"
                            style={{ display: "none" }}
                          >
                            Sportsbook
                          </span>
                          <span
                            id="sportsBookIcon_1"
                            className="game-sportsbook"
                            style={{ display: "none" }}
                          >
                            Premium Tennis
                          </span>
                          <span
                            id="sportsBookIcon_2"
                            className="game-sportsbook"
                            style={{ display: "none" }}
                          >
                            Premium Cricket
                          </span> */}
                          {obj.days == 0 &&
                          obj.hours == 0 &&
                          obj?.years == 0 &&
                          obj?.months == 0 &&
                          obj.minutes > 0 &&
                          obj?.minutes < profileData?.beforeInPlay ? (
                            <span id="dateTimeInfo" className="time">
                              Starting in {obj?.minutes}'
                            </span>
                          ) : item.status == "in_play" ? (
                            <span id="dateTimeInfo" className="time">
                              In-Play 
                            </span>
                          ) : (
                            <span id="dateTimeInfo" className="time">
                              {helpers.matchDateTime(item.eventDateTime)}
                            </span>
                          )}
                          {/* {item.status == "in_play" ? (
                            <span id="dateTimeInfo" className="time">
                              In-Play
                            </span>
                          ) : obj.days == 0 &&
                            obj.hours == 0 &&
                            obj?.years == 0 &&
                            obj?.months == 0 ? (
                            <span id="dateTimeInfo" className="time">
                              Starting in {obj.minutes}
                            </span>
                          ) : (
                            <span id="dateTimeInfo" className="time">
                              {helpers.matchDateTime(item.eventDateTime)}
                            </span>
                          )} */}
                          {/* <span
                            id="sportsBookEIcon_1"
                            className="game-E"
                            style={{ display: "none" }}
                          >
                            <i></i>Soccer
                          </span>
                          <span
                            id="sportsBookEIcon_137"
                            className="game-E"
                            style={{ display: "none" }}
                          >
                            <i></i>e-Soccer
                          </span>
                          <span
                            id="sportsBookEIcon_4"
                            className="game-E"
                            style={{ display: "none" }}
                          >
                            <i></i>Cricket
                          </span>
                          <span
                            id="sportsBookEIcon_2"
                            className="game-E"
                            style={{ display: "none" }}
                          >
                            <i></i>Tennis
                          </span> */}
                        </dt>
                        <dd id="eventName">
                          {(() => {
                            // Split on " v " (case-insensitive) to handle team names with "/" or other characters
                            const parts = item?.eventName?.split(/\s+v\s+/i);
                            const team1 = parts?.[0] || item?.eventName;
                            const team2 = parts?.[1] || "";
                            
                            // Display score if available
                            if (item?.score) {
                              return team2 ? (
                                <>
                                  {team1}
                                  <span
                                    style={{ color: '#e4550f', fontWeight: "700" }}
                                  >
                                    {" " + (item?.score?.split(" || ")[0] || item?.score) + " "} {/* Render score with styling */}
                                  </span>
                                  {team2}
                                </>
                              ) : (
                                <>
                                  {item?.eventName}
                                  <span
                                    style={{ color: '#e4550f', fontWeight: "700" }}
                                  >
                                    {" " + (item?.score?.split(" || ")[0] || item?.score)} {/* For single team name */}
                                  </span>
                                </>
                              );
                            } else {
                              // Default display without score
                              return team2 ? (
                                <>
                                  {team1}
                                  <span style={{ color: "#508d0e", fontWeight: "700" }}> V </span>
                                  {team2}
                                </>
                              ) : (
                                item?.eventName
                              );
                            }
                          })()}
                        </dd>
                      </dl>
                    </Link>
                    <a
                      id="multiMarketPin"
                      onClick={() => {
                        if (!isEmpty(user)) {
                          handelAddMultiMarket(item.eventId);
                          setLoading(true);
                        } else {
                          
                          startTransition(() => navigate("/login"));
                        }
                      }}
                      className={item.multi_market > 0 ? "pin-on" : "pin-off"}
                      href="javascript:void(0)"
                    ></a>
                    
                  </li>
                  {/* {item?.back_odds && item?.back_odds?.length > 0 && (
                    <MatchDetailsHome
                      selections={item?.runners || []}
                      back_odds={item?.back_odds || []}
                      lay_odds={item?.lay_odds || []}
                      details={item}
                      totalMatched={item?.totalMatched || 0}
                      setSlipObj={setSlipObj}
                      setSelections={() => {}}
                      slipObj={slipObj}
                      handelBetFairPositions={handelBetFairPositions}
                      resetSelection={resetSelection}
                      setCondi={setCondi}
                      betType="betFair"
                      profileData={profileData}
                      user={user}
                      messaageBox={messaageBox}
                      betFairMs={item?.matchOddsData?.ms || 1}
                      setMarketDepth={() => {}}
                      marketId={item?.marketId}
                      marketName="Match Odds"
                    />
                  )} */}
                  {/* {console.log("filteredData", filteredData)} */}
                  </>
                )
              );
            })}

          
        </ul>
        
      </div>
     
    </div>
  );
};

export default InplayTabs;